import React from "react";
import { SOCIALS } from "../data/site";
import { Section, Eyebrow } from "./ui-kit";

const ICONS = {
  Facebook: (
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12Z" />
  ),
  Instagram: (
    <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 1.8c-3.15 0-3.52.01-4.76.07-1.15.05-1.77.24-2.18.4-.55.22-.94.47-1.35.88-.41.41-.66.8-.88 1.35-.16.41-.35 1.03-.4 2.18-.06 1.24-.07 1.61-.07 4.76s.01 3.52.07 4.76c.05 1.15.24 1.77.4 2.18.22.55.47.94.88 1.35.41.41.8.66 1.35.88.41.16 1.03.35 2.18.4 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c1.15-.05 1.77-.24 2.18-.4.55-.22.94-.47 1.35-.88.41-.41.66-.8.88-1.35.16-.41.35-1.03.4-2.18.06-1.24.07-1.61.07-4.76s-.01-3.52-.07-4.76c-.05-1.15-.24-1.77-.4-2.18a3.6 3.6 0 0 0-.88-1.35 3.6 3.6 0 0 0-1.35-.88c-.41-.16-1.03-.35-2.18-.4-1.24-.06-1.61-.07-4.76-.07Zm0 3.06a4.98 4.98 0 1 1 0 9.96 4.98 4.98 0 0 1 0-9.96Zm0 8.21a3.23 3.23 0 1 0 0-6.46 3.23 3.23 0 0 0 0 6.46Zm6.34-8.41a1.16 1.16 0 1 1-2.32 0 1.16 1.16 0 0 1 2.32 0Z" />
  ),
  TikTok: (
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.01-2.82h-3.1v12.4a2.6 2.6 0 0 1-2.6 2.5 2.6 2.6 0 0 1 0-5.2c.27 0 .53.04.77.12v-3.2a5.74 5.74 0 0 0-.77-.05 5.73 5.73 0 1 0 5.73 5.73V9.01a7.34 7.34 0 0 0 4.3 1.38v-3.1a4.28 4.28 0 0 1-3.32-1.47Z" />
  ),
};

export const StayConnected = ({ tone = "tinted" }) => (
  <Section tone={tone} data-testid="stay-connected">
    <div className="max-w-2xl mx-auto text-center">
      <Eyebrow>Stay connected with us</Eyebrow>
      <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900">
        Follow us on our socials!
      </h2>
      <p className="mt-4 text-lg text-stone-700 leading-relaxed">
        See more moments, activities and day-out highlights from life at Spire Inclusion.
        Give us a follow to keep up with everything we get up to.
      </p>
      <ul className="mt-8 flex flex-wrap items-center justify-center gap-4">
        {SOCIALS.map((s) => (
          <li key={s.name}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow Spire Inclusion on ${s.name} (opens in a new tab)`}
              data-testid={`stay-connected-${s.name.toLowerCase()}`}
              className="inline-flex items-center gap-3 rounded-full bg-white border-2 border-stone-300 px-6 py-3 text-lg font-semibold text-stone-900 transition-colors duration-200 hover:border-orange-600 hover:bg-orange-50"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6 text-orange-700" aria-hidden="true">
                {ICONS[s.name]}
              </svg>
              {s.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </Section>
);
